import { IReduxAction } from '../IReduxAction'
import ActionTypes from './types'

export interface IUserState {
  allDoctors: any
  errorCode: string
  errorMessage: string
}

export const initState: IUserState = {
  allDoctors: {},
  errorCode: '',
  errorMessage: ''
}

export default (state = initState, action: IReduxAction): IUserState => {
  switch (action.type) {
    case ActionTypes.get_doctors_begins:
      return state

    case ActionTypes.get_doctors_success:
      return {
        ...state,
        allDoctors: action.payload.data.allDoctors
      }

    case ActionTypes.get_doctors_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case ActionTypes.get_doctors_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case ActionTypes.update_doctor:
      const { doctorId, doctorData } = action.payload.data
      const { allDoctors } = state
      for (const doctor in allDoctors) {
        if (doctor) {
          if (doctor === doctorId) {
            allDoctors[doctor] = doctorData
          }
          return allDoctors[doctor]
        }
      }
      return {
        ...state,
        allDoctors: {
          [`${doctorId}`]: doctorData,
          ...allDoctors
        }
      }
    default:
      return {
        ...state,
        allDoctors
      }
  }
}



// WEBPACK FOOTER //
// ./src/store/careProfessionals/index.ts